module.exports = __webpack_public_path__ + "assets/9c916e9ed070e8878a54bca27aac4e97.png";